'use client'

import { useRef } from 'react'
import { cn } from '@/lib/cn'

type HeroXLCircleProps = {
  circleSize?: number
  easingFactor?: number
  brandColor?: string
  backgroundColor?: string
  className?: string
}

export default function HeroXLCircle({
  backgroundColor = '#FFFCF2',
  className,
}: HeroXLCircleProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  return (
    <div
      ref={containerRef}
      className={cn(
        'w-[90%] max-w-3xl place-self-center z-10 relative overflow-visible pointer-events-none',
        className,
      )}
      aria-hidden='true'
    >
      {/* SVG logo on top */}
      <svg
        viewBox='0 0 488 179'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='fp-hero-circle-mask'
        aria-hidden='true'
        className='w-full relative z-10'
      >
        <defs>
          <mask id='text-mask'>
            <rect width='100%' height='100%' fill='white' />
            <path
              d='M176.759 41.6369C188.757 41.6369 198.955 46.022 206.159 54.2092C213.369 62.4023 217.621 74.4498 217.621 89.8391C217.621 104.935 213.093 116.839 205.558 124.964C198.024 133.087 187.445 137.476 175.255 137.476C170.893 137.476 165.973 136.683 161.501 134.938C157.028 133.192 153.035 130.507 150.477 126.745L149.563 125.403V167.867H121.798V43.7131H149.563V55.1447L150.469 53.8879C156.736 45.1886 168.023 41.6369 176.759 41.6369ZM168.675 63.8557C162.898 63.8557 157.772 66.084 154.098 70.4768C150.431 74.8615 148.247 81.3572 148.247 89.8391C148.247 98.1348 150.431 104.491 154.101 108.781C157.776 113.079 162.902 115.256 168.675 115.256C180.509 115.256 189.292 104.931 189.292 89.6506C189.292 74.5677 180.515 63.8557 168.675 63.8557Z'
              fill='black'
            />
            <path
              d='M261.374 43.7132V135.21H233.61V43.7132H261.374ZM261.374 10.8675V33.0863H233.61V10.8675H261.374Z'
              fill='black'
            />
            <path
              d='M324.987 41.6369C344.267 41.6369 364.691 50.3078 370.434 73.7678L344.531 78.133C343.262 73.4548 341.002 69.9144 337.988 67.5266C334.879 65.0633 331.004 63.8557 326.679 63.8557C321.397 63.8557 316.134 65.6412 312.193 69.7678C308.252 73.895 305.686 80.3082 305.686 89.4621C305.686 98.8977 308.299 105.36 312.266 109.465C316.233 113.569 321.497 115.256 326.679 115.256C332.139 115.256 336.44 113.667 339.62 111.011C342.679 108.455 344.664 104.938 345.665 100.98L371.549 105.342C368.236 117.653 361.304 125.646 352.911 130.583C344.384 135.599 334.327 137.476 324.987 137.476C309.589 137.476 297.697 132.466 289.653 123.97C281.604 115.47 277.358 103.426 277.358 89.2727C277.358 75.2331 282.203 63.3307 290.56 54.9397C298.917 46.5488 310.817 41.6369 324.987 41.6369Z'
              fill='black'
            />
            <path
              d='M428.743 41.6369C441.622 41.637 453.81 45.4324 462.771 53.3108C471.721 61.1803 477.5 73.1652 477.5 89.6506C477.5 106.136 471.721 118.074 462.772 125.896C453.811 133.727 441.623 137.476 428.743 137.476C415.768 137.476 403.628 133.727 394.738 125.897C385.86 118.076 380.173 106.139 380.173 89.6506C380.173 73.1624 385.859 61.1771 394.739 53.3088C403.629 45.4319 415.77 41.6369 428.743 41.6369ZM428.743 63.8557C422.867 63.8557 417.785 66.1819 414.184 70.5988C410.59 75.0063 408.502 81.4532 408.502 89.6506C408.502 97.7523 410.543 104.152 414.113 108.536C417.693 112.931 422.774 115.256 428.743 115.256C434.618 115.256 439.744 112.931 443.392 108.54C447.033 104.158 449.171 97.7576 449.171 89.6506C449.171 81.4506 447.034 75.0037 443.393 70.5969C439.745 66.1818 434.619 63.8558 428.743 63.8557Z'
              fill='black'
            />
            <path
              d='M106.699 10.8675V36.2953H39.3926V109.783H106.699V135.21H10.5V10.8675H106.699Z'
              fill='black'
            />
            <path d='M106.699 58.6262V84.054H62.2015V58.6262H106.699Z' fill='black' />
          </mask>
        </defs>

        {/* Background rectangle with mask applied */}
        <rect width='100%' height='100%' fill={backgroundColor} mask='url(#text-mask)' />
      </svg>
    </div>
  )
}
